import React, { ChangeEvent } from 'react';
import Delete from '@material-ui/icons/Delete';
import {
    makeStyles,
    MenuItem,
    Select,
    TableCell,
    TableRow,
    TextField,
} from '@material-ui/core';
import { ITheme } from '../../themes/custom/ITheme';
import { useTypedSelector } from '../../shared/hooks/useTypedSelector';
import { IMember } from './TeamDialog';

interface Props {
    member: IMember;
    index: number;
    last: boolean;
    onChange: (index: number, member: IMember) => void;
    onRemove: () => void;
}

const useStyles = makeStyles((theme: ITheme) => ({
    wrapper: {},

    textField: {
        borderRadius: '7px',
        marginBottom: '9px',
        padding: '0px',
        '& .MuiInputBase-input': {
            border: '1px solid ' + theme.custom.palette.grey,
            padding: '0px 35px 0 5px',
            height: '28px',
            lineHeight: '28px',
        },
    },
    select: {
        borderRadius: '7px',
        marginBottom: '9px',
        padding: '0px',
        '& .MuiSelect-outlined': {
            border: '1px solid ' + theme.custom.palette.grey,
            padding: '0px 35px 0 5px',
            height: '28px',
            lineHeight: '28px',
        },
    },
    delete: {
        cursor: 'pointer',
    },
}));

const TeamMember: React.FC<Props> = (props) => {
    const classes = useStyles(props);
    const { member, index, last, onChange, onRemove } = props;

    const { data: productData } = useTypedSelector(
        (state) => state.od.loadProduct
    );

    const handleChangeSize = (event: React.ChangeEvent<{ value: unknown }>) => {
        const id = event.target.value as number;
        if (productData && productData.sizes.length > 0) {
            const size = productData.sizes
                .filter((size) => size.idAttribute === id)
                .pop();
            if (size) {
                onChange(index, {
                    ...member,
                    size: size,
                });
            }
        }
    };

    return (
        <TableRow>
            <TableCell>
                <TextField
                    id={'name' + member.id}
                    variant="outlined"
                    size="small"
                    type="text"
                    defaultValue={member.name}
                    className={classes.textField}
                    onChange={(e: ChangeEvent<HTMLInputElement>) => {
                        onChange(index, {
                            ...member,
                            name: e.currentTarget.value,
                        });
                    }}
                />
            </TableCell>
            <TableCell>
                <TextField
                    id={'number' + member.id}
                    variant="outlined"
                    size="small"
                    type="text"
                    defaultValue={member.number}
                    className={classes.textField}
                    onChange={(e: ChangeEvent<HTMLInputElement>) => {
                        onChange(index, {
                            ...member,
                            number: e.currentTarget.value,
                        });
                    }}
                />
            </TableCell>
            <TableCell>
                <Select
                    value={member.size?.idAttribute ?? ''}
                    onChange={handleChangeSize}
                    variant={'outlined'}
                    className={classes.select}
                >
                    {productData &&
                        productData.sizes.map((size) => (
                            <MenuItem
                                key={size.idAttribute}
                                value={size.idAttribute}
                            >
                                {size.name}
                            </MenuItem>
                        ))}
                </Select>
            </TableCell>
            {!last && (
                <TableCell onClick={onRemove}>
                    <Delete className={classes.delete} />
                </TableCell>
            )}
            {last && <TableCell></TableCell>}
        </TableRow>
    );
};

export default TeamMember;
